import React, { FC } from 'react';
import styles from './Button-Login.module.css';
 

export const ButtonLogin: React.FC <{onClick?: React.MouseEventHandler<HTMLElement>, text: any}>  = ({onClick, text}) => {
  return (
    <div className={styles.ButtonPrimary}>
      <button onClick={onClick}className="pds-button pds-button-secondary">
       {text}</button>
    </div>
  );
};
export default ButtonLogin;
